import { useContext } from "react";

import { AuthContext } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import Routers from "./routes/Routers";
import "./App.css";

function App() {
  const { isLoading } = useContext(AuthContext);

  if (isLoading) {
    return (
      <div className="App">
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <CartProvider>
      <Routers />
    </CartProvider>
  );
}

export default App;
